import { render, staticRenderFns } from "./SettingsBillingProvider.vue?vue&type=template&id=426471b3&"
import script from "./SettingsBillingProvider.vue?vue&type=script&lang=ts&"
export * from "./SettingsBillingProvider.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports